import React, { useEffect, useRef, useState } from 'react';

const InfiniteScrolling = ({ children, isLoading, onLoadMore }) => {
  const [loadingNextPage, setLoadingNextPage] = useState(false);
  const observerTarget = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      async entries => {
        if (entries[0].isIntersecting && !loadingNextPage) {
          setLoadingNextPage(true);
          await onLoadMore();
          setLoadingNextPage(false);
        }
      },
      { threshold: 0.3 },
    );

    if (observerTarget.current) {
      observer.observe(observerTarget.current);
    }

    return () => {
      if (observerTarget.current) {
        observer.unobserve(observerTarget.current);
      }
    };
  }, [observerTarget, loadingNextPage, onLoadMore]);
  return (
    <>
      {children}
      <div ref={observerTarget} />
      <div>
        {isLoading ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img
              src="/assets/img/Cater-Loader_1.gif"
              alt="Loading..."
              style={{ width: '150px', marginBottom: '12px' }}
            />
          </div>
        ) : null}
      </div>
    </>
  );
};
export default InfiniteScrolling;
